// The platform administrator's property selector contains every hotel, so its
// length cannot describe the selected hotel's group.
export function hasMultipleGroupProperties(hotel, isLoxeAdmin = false) {
  if (!hotel?.hotelGroup) return false;
  if (Number.isInteger(hotel.hotelGroupPropertyCount)) {
    return hotel.hotelGroupPropertyCount > 1;
  }
  if (!isLoxeAdmin && Array.isArray(hotel.group) && hotel.group.length > 0) {
    return hotel.group.length > 1;
  }
  // Preserve existing behavior until the server provides the group size.
  return true;
}
